import { ComputeFieldComponent } from "../computeFields";
import { Bibliography } from "../types";
import { DimensionsFormatting } from "./shared/dimensions";
import { SeparatedList } from "./shared/utils";

export const BibliographieDimensionsCF: ComputeFieldComponent<
  Pick<Bibliography, "bibliographieDescriptionDimensions">
> = ({ input, ...props }) => {
  return (
    <DimensionsFormatting
      input={{ ...input.bibliographieDescriptionDimensions }}
      {...props}
    />
  );
};

function formatPeriodicLocationSuffix(input: {
  bibliographieDescriptionInclureVillePaysDansResume?: boolean;
  bibliographieDescriptionVille?: string;
  bibliographieDescriptionPays?: string;
}): string | null {
  if (!input.bibliographieDescriptionInclureVillePaysDansResume) {
    return null;
  }
  const parts = [
    input.bibliographieDescriptionVille,
    input.bibliographieDescriptionPays,
  ]
    .map((s) => s?.trim())
    .filter(Boolean);
  const suffix = parts.length > 0 ? ` [${parts.join(", ")}]` : null;
    return suffix;
}

export const BibliographieLongSummaryCF: ComputeFieldComponent<
  Pick<
    Bibliography,
    | "bibliographieDescriptionNomRevue"
    | "bibliographieDescriptionAuteur"
    | "bibliographieDescriptionTitre"
    | "bibliographieDescriptionNumeroRevue"
    | "bibliographieDescriptionDatesPublication"
    | "bibliographieDescriptionPageArticle"
    | "bibliographieDescriptionSousTitre"
    | "bibliographieDescriptionVille"
    | "bibliographieDescriptionPays"
    | "bibliographieDescriptionInclureVillePaysDansResume"
    | "bibliographieDescriptionEditeur"
    | "bibliographieDescriptionCollection"
    | "bibliographieDescriptionAnnee"
  >
> = ({ input, lineBreak = false, ...props }) => {
  if (input.bibliographieDescriptionNomRevue) {
    return (
      <SeparatedList
        {...props}
        lineBreak={lineBreak}
        input={[
          input.bibliographieDescriptionAuteur,

          input.bibliographieDescriptionTitre && (
            <>« {input.bibliographieDescriptionTitre} »</>
          ),

          input.bibliographieDescriptionNomRevue && (
            <>
              <i>{input.bibliographieDescriptionNomRevue}</i>
              {formatPeriodicLocationSuffix(input)}
            </>
          ),

          input.bibliographieDescriptionNumeroRevue && (
            <>n°{input.bibliographieDescriptionNumeroRevue}</>
          ),

          input.bibliographieDescriptionDatesPublication,

          input.bibliographieDescriptionPageArticle &&
            input.bibliographieDescriptionPageArticle !==
              encodeURI("n. p.") && (
              <>p. {input.bibliographieDescriptionPageArticle}</>
            ),
        ]}
      />
    );
  }

  return (
    <SeparatedList
      {...props}
      lineBreak={lineBreak}
      input={[
        input.bibliographieDescriptionAuteur,
        <i>{input.bibliographieDescriptionTitre}</i>,
        input.bibliographieDescriptionSousTitre,
        input.bibliographieDescriptionVille,
        input.bibliographieDescriptionEditeur,
        input.bibliographieDescriptionCollection,
        input.bibliographieDescriptionAnnee,
      ]}
    />
  );
};
